require('./jquery.fallings.min.js');

var windowSize = $(window).width();

/**
 * Slim select init
 */
let selectDropdown = document.querySelector('.form__input--select');

if (selectDropdown) {
	new SlimSelect({
		select: '#sortSelect',
		settings: {
			showSearch: false,
			contentLocation: selectDropdown,
		}
	});

	new SlimSelect({
		select: '#deliverySelect',
		settings: {
		  showSearch: false,
		  contentLocation: selectDropdown,
		}
	});

	new SlimSelect({
		select: '#languageSelect',
		settings: {
		  showSearch: false,
		  openPosition: 'up'
		},
		events: {
			afterChange: (newVal) => {
				window.location.href = newVal[0].data.href;
			}
		}
	});
}


/**
 * PhotoSwipe gallery init
 */
if ($(".pswp-gallery").length) {
	// Photoswipe init        
	$(".pswp-gallery").photoSwipe(
		".gallery__item-container",
		{
			bgOpacity: 0.8,
			shareEl: false,
			captionEl: false,
			tapToClose: true
		}
	);
}


/**
 * Attach dynamic click listeners
 */
$(document).on("click", "[data-trigger=click]", function(e) {
	if ($(this).data()["preventDefault"]) {
		e.preventDefault();
	}

	var params = [];

	if ($(this).attr("data-params")) {
		params = eval("[" + $(this).attr("data-params") + "]");
	}

	params.push(e);

	var controller = eval($(this).attr("data-controller"));
	controller.apply(this, params);
});


/**
 * Disabled links
 */
$(document).on("click", "a[disabled]", function(e) {
	e.preventDefault();
	e.stopPropagation();
	e.stopImmediatePropagation();
});


/**
 * Parallax init
 */
$.each($("[data-parallax]"), function(ind, val) {

    let velocity = $(this).attr("data-parallax");
    let initialPos = parseFloat($(this).css("top"), 10);

    if(window.innerWidth > 992) {
       
        $(val).fallings({

            velocity: velocity,
            initialPosition: initialPos,
            bgParallax: false,
            bgPercent: "0%",
            onClass: "fallings-visible",
            offClass: "fallings-invisible"

        });
    }
});


/**
 * Update elements height
 */
(function () {
	let elements = $('.swiper--category .section__category-title, .blog__listing .blog__body, .section__item .section__category-title.section__title-small');

	elements.each(function () {
		let maxHeight = Math.max.apply(null, $(this).map(function () {
			return $(this).height();
		}).get());

		$(this).height(maxHeight);
	});
})();


/**
 * Change inner padding on header menu when resizing
 */
if (windowSize >= 1050) {
	(function () {
		let windowWidth = document.documentElement.clientWidth + 4;
		let headerContainerWidth = document.querySelector('.header__bottom .container').clientWidth;
		let sidesMargin = windowWidth - headerContainerWidth;

		if($(window).width() <= 1450) {
			sidesMargin = windowWidth - headerContainerWidth + 20;
		}

		$(window).on('resize', function() {
			$(".main-nav-child").each(function(i,el) {
				$(el).css('padding-left', sidesMargin / 2 + 23);
			});
		}).trigger("resize");
	})();

	/**
	 * Change product image on hover
	 */
	if($(".section__item img.hover-img").length > 0) {
		$(".section__item img.main-img").each(function() {
			let $this = $(this);
			let imgSrc = $this.attr('src');
			let imgSrcHover = $this.next().data("src");
			let sectionItem = $this.closest('.section__item');
			
			sectionItem.on("mouseover", function() {
				$this.attr('src', imgSrcHover);
			});

			sectionItem.on("mouseout", function() {
				$this.attr("src", imgSrc);
			});
		});
	}
}


/**
 * Toggle product listing filters visibility
 */
if ($('.sidebar__filters').length) {
	$('.filter__title').each(function() {
		$(this).on('click', function() {
			$(this).toggleClass('open');
			$(this).siblings('.filter__content').toggleClass('visible');
		});
	});
}


/**
 * Back to top button init
 */
$(window).on('load', function() {
	let btn = $('#to-top-btn');

	$(window).on("scroll", function() {
		if ($(window).scrollTop() > 300) {
			btn.addClass('show');
		} else {
			btn.removeClass('show');
		}
	});

	btn.on('click', function(e) {
		e.preventDefault();
		$('html, body').animate({scrollTop:0}, '300');
	});
});


/**
 * Filters price range slider init
 */
(function () {
	let priceSlider = $("#price-slider");

	if (priceSlider.length) {
	
		let sliderOptions = {
			start: [ 
				parseFloat(priceSlider.attr("data-min-value"), 10), 
				parseFloat(priceSlider.attr("data-max-value"), 10)
			],
			margin: 1,
			connect: true,
			behaviour: "snap",
			range: {
				min: parseFloat(priceSlider.attr("data-min"), 10),
				max: parseFloat(priceSlider.attr("data-max"), 10)
			}
		};
	
		if (sliderOptions.range.min == sliderOptions.range.max) {
			if (sliderOptions.range.min > 1) {
				sliderOptions.range.min--;
				sliderOptions.start[0] = sliderOptions.range.min;
			} else {
				sliderOptions.range.max++;
				sliderOptions.start[1] = sliderOptions.range.max;
			}
		}
	
		noUiSlider.create(priceSlider[0], sliderOptions);
	
		let minPriceInput = priceSlider.siblings(".min-price-input");
		let maxPriceInput = priceSlider.siblings(".max-price-input");
		let minPriceText  = priceSlider.siblings(".filter__values").find(".price-slider-min span");
		let maxPriceText  = priceSlider.siblings(".filter__values").find(".price-slider-max span");
	
		priceSlider[0].noUiSlider.on("update", function (values, handle) {
	
			let value = values[handle];
	
			value = parseInt(value, 10);
	
			if (handle) {
				maxPriceText.text(value);
			} else {
				minPriceText.text(value);
			}
		});
	
		priceSlider[0].noUiSlider.on("set", function (values, handle) {
	
			let value = values[handle];
	
			value = parseInt(value, 10);
	
			if (handle) {
				maxPriceInput.val(value).change();
				maxPriceText.text(value);
			} else {
				minPriceInput.val(value).change();
				minPriceText.text(value);
			}
		});
	}
})();


/**
 * Toggle invoice data visibility in shopping cart
 */
$('.js-toggle-invoice').on("change", function() {

	if ($(this).is(":checked")) {
		$(".invoice").addClass('invoice--show');
	} else {
		$(".invoice").removeClass('invoice--show');
	}

	$(window).resize();
	$(window).scroll();
});


/**
 * Toggle order submit button active state on GDPR agree radio change
 */
$(".gdpr-agree-checkbox").on("change", function() {
	let submitButton = $(this).closest("form").find("button");

	if ($(this).is(":checked")) {
		submitButton.attr("disabled", false);
	} else {
		submitButton.attr("disabled", true);
	}
}).trigger("change");


/**
 * Change mobile filter button on scroll
 */
(function () {
	const filterIcon = document.querySelector('.btn--filter');
	
	if (filterIcon && $('.section--product-listing').length > 0) {
		$(window).on("scroll", function() {
			if ($(this).scrollTop() >= 200){
				$('.btn--filter').addClass('show-filter');
				if(isOnScreen ($('.footer__general'))) {
					$('.btn--filter').addClass('bottom').css('bottom', $('.footer').height() + 50);
				} else {
					$('.btn--filter').removeClass('bottom').css('bottom', 'auto');
				}
				
			} else {
				$('.btn--filter').removeClass('show-filter');
			}
		});
	}
})();


/**
 * Check if the element is visible on screen
 */
function isOnScreen (elem) {
	if (elem && elem.length) {
	  var win = $(window);
	  
	  var viewport = {
		  top : win.scrollTop(),
		  left : win.scrollLeft()
	  };
	
	  
	  viewport.right = viewport.left + win.width();
	  viewport.bottom = viewport.top + win.height();
	  
	  var bounds = elem.offset();
	
	  bounds.right = bounds.left + elem.outerWidth();
	  bounds.bottom = bounds.top + elem.outerHeight();
	  
	  return (!(viewport.right < bounds.left || viewport.left > bounds.right || viewport.bottom < bounds.top || viewport.top > bounds.bottom));
	}
  }


/**
 * Overlay close
 */
$("#overlay").on("click", function() {
	let bodyTop = -1 * parseFloat($(document.body).css("top"), 10);

	$(document.body).removeClass("filter-mobile--show");
	
	$(window).scrollTop(bodyTop);
});


/**
 * Mobile filter panel close
 */
$('.mobile-filter-title .icon-close').on('click', function() {
	$(this).closest('.filter-mobile--show').removeClass('filter-mobile--show');
});


/**
 * Increment quantity value
 */
function incrementValue(e) {
	e.preventDefault();
	let fieldName = $(e.target).data('field');
	let parent = $(e.target).closest('div');
	let currentVal = parseInt(parent.find('input[name=' + fieldName + ']').val(), 10);
  
	if (!isNaN(currentVal)) {
	  parent.find('input[name=' + fieldName + ']').val(currentVal + 1);
	} else {
	  parent.find('input[name=' + fieldName + ']').val(0);
	}
}


/**
 * Decrement quantity value
 */
function decrementValue(e) {
	e.preventDefault();
	let fieldName = $(e.target).data('field');
	let parent = $(e.target).closest('div');
	let currentVal = parseInt(parent.find('input[name=' + fieldName + ']').val(), 10);

	if (!isNaN(currentVal) && currentVal > 0) {
		parent.find('input[name=' + fieldName + ']').val(currentVal - 1);
	} else {
		parent.find('input[name=' + fieldName + ']').val(0);
	}
}

/**
 * Toggle product quantity increment
 */
$('.input-group').on('click', '.button-plus', function(e) {
	incrementValue(e);
});


/**
 * Toggle product quantity decrement
 */
$('.input-group').on('click', '.button-minus', function(e) {
	decrementValue(e);
});


/**
 * Set loading effect on no-ajax form submit button
 */
$(".no-ajax-form").on("submit", function() {
	$(this).data("loading", true);
	$(this).find("button[type=submit], button:not([type])")
		.addClass("btn--loading")
		.attr("disabled", true)
		.prop("disabled", true);
});


/**
* Floating labels
 */
$(":input").on("focus", function() {

	var group = $(this).closest(".form__group");
	group.addClass("form__group--focused");

});

$(":input").on("blur", function() {
	var group = $(this).closest(".form__group");
	group.removeClass("form__group--focused");
});

$(":input").on("change", function() {
	var group = $(this).closest(".form__group");

	if (
		($(this).val() !== null && $(this).val() !== "") ||
	 	$(this).is("select")
	) {
		group.addClass("form__group--filled");
	}
	else {
		group.removeClass("form__group--filled");
	}
}).change();

$(":input").on("input", function() {
	var group = $(this).closest(".form__group");
	var append = group.find(".form__append-fix")

	append.html($(this).val().replace(new RegExp(" ", "g"), "&nbsp;"));
});


/**
* Show tooltip on add to cart button
 */
$('.product__order .js-add-to-cart').on('click', function() {
	$('.cart-tooltip').addClass('visible');

	setTimeout(() => {
		$('.cart-tooltip').removeClass('visible');
	}, 2500);
});


/**
 * Main navigation trigger
 */
var beforeNavScroll = null;

$("#nav-trigger").on( "click" , function(e) {
	e.preventDefault();

	var $body = $(document.body);

	if ($body.hasClass("nav-visible")) {
		$body.removeClass("nav-visible");
		$(window).scrollTop(beforeNavScroll);
	}
	else {
		beforeNavScroll = $(window).scrollTop();
		$body.addClass("nav-visible");
	}
});


if (windowSize <= 1050) {
	$('.floating .login-btn--profile').on('click', function() {
	  $(this).next().toggleClass('visible');
	});

	/**
	* Show nav for mobile
	*/
	$(".main-nav__item--has-children .main-nav__child-toggler").on( "click" , function(e) {
		e.preventDefault();
	
		var parent = $(this).parent(".main-nav__item--has-children");
		var mainNav = parent.parent();
		mainNav.toggleClass('childrenShown');
		parent.toggleClass('main-nav__item--show-children');
		parent.siblings().toggleClass('main-nav__item--hidden');
		mainNav.find('.main-nav-child').removeClass('childrenShown').children('.main-nav-child__item').removeClass('main-nav-child__item--show-children');
	});

	$(".main-nav-child__item--has-children .main-nav__child-toggler").on( "click" , function(e) {
		e.preventDefault();
	
		var parent = $(this).parent(".main-nav-child__item--has-children");
		var mainNavChild = parent.parent();
		mainNavChild.toggleClass('childrenShown');
		parent.toggleClass('main-nav-child__item--show-children');
		parent.siblings().toggleClass('main-nav-child__item--hidden');
	});
}


/**
 * Filter navigation trigger
 */
$(".js-toggle-filter").on("click", function(e) {
	e.preventDefault();

	var scrollTop = $(window).scrollTop();
	var bodyTop = -1 * parseFloat($(document.body).css("top"), 10);

	$(document.body).toggleClass("filter-mobile--show");

	if ($(document.body).hasClass("filter-mobile--show")) {
		$(document.body).css("top", -scrollTop + "px")
	} else {
		$(window).scrollTop(bodyTop);
	}
});
